<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import { debounce } from "../../../state/helpers";
import config from "../../../config/config";
import { error_message, success_message } from "../../../state/helpers";
import { required, minLength, maxLength, helpers } from "vuelidate/lib/validators";
import DropzonePopup from "../../../components/widgets/dropzone-popup.vue";
const mobileNumberValidator = helpers.regex("alphaNumAndDot", /^(\+\d{1,3}[- ]?)?\d{10}$/);
export default {
  page: {
    title: "User",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: { Layout, DropzonePopup },
  computed: mapGetters("user", ["getAllUser", "loading", "userCount", "pagination"]),
  data() {
    const { perPage, status, orderBy, sortBy } = this.$route.query;
    return {
      config: config,
      title: "Users",
      sortBy: sortBy || "created_at",
      sortDesc: orderBy && orderBy != "" ? orderBy : true,
      limit: 1,
      perPage: perPage || 5,
      search: "",
      status: status == undefined ? "1" : status,
      user: {
        first_name: "",
        last_name: "",
        email: "",
        mobile_number: "",
        status: "",
        image: "",
      },
      profile_image_delete_url: process.env.VUE_APP_APIURL + "delete-user-image",
      searchData: debounce(() => {
        if (!this.init) {
          const { status, orderBy, sortBy } = this.$data;
          this.$router.replace({
            name: "user-list",
            query: { status, orderBy, sortBy },
          });
        }
        this.getUserList();
        this.init = false;
      }, 500),
      fields: [
        { key: "profile_image", label: "#", sortable: false },
        { key: "users", label: "Name", sortable: true },
        { key: "email", label: "Email", sortable: true },
        { key: "mobile_number", label: "Mobile Number", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "action", label: "Action", sortable: false },
      ],
    };
  },
  validations: {
    user: {
      first_name: { required },
      last_name: { required },
      email: { required },
      mobile_number: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(13),
        mobileNumberValidator,
      },
    },
  },
  mounted() {
    this.getUserList();
  },
  methods: {
    ...mapActions("user", ["getUsers", "deleteUser", "blockById", "unblockById", "addUser"]),

    getUserList(page = 1) {
      var filters = {
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        perPage: this.perPage,
      };
      this.getUsers(filters);
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getUserList();
    },
    deleteById(id) {
      if (confirm("Are you sure you want to delete this user")) {
        this.deleteUser({ id: id }).then((response) => {
          if (response.data.code === 200) {
            success_message(response.data.msg);
            this.getUserList();
          } else {
            error_message(response.data.msg);
          }
        });
      }
    },
    blockUserById(id) {
      if (confirm("Are you sure you want to block?")) {
        this.blockById({ id: id }).then((response) => {
          if (response.data.code === 200) {
            success_message(response.data.msg);
            this.getUserList();
          } else {
            error_message(response.data.msg);
          }
        });
      }
    },
    unblockUserById(id) {
      if (confirm("Are you sure you want to Unblock?")) {
        this.unblockById({ id: id }).then((response) => {
          if (response.data.code === 200) {
            success_message(response.data.msg);
            this.getUserList();
          } else {
            error_message(response.data.msg);
          }
        });
      }
    },
    resetForm() {
      this.$v.$reset();
    },
    submitAddUser() {
      this.$v.$touch();
      if (this.$v.user.$invalid) {
        return;
      } else {
        const fd = new FormData();
        fd.append("first_name", this.user.first_name);
        fd.append("last_name", this.user.last_name);
        fd.append("email", this.user.email);
        fd.append("status", this.user.status);
        fd.append("mobile_number", this.user.mobile_number);
        if (this.user.image) {
          fd.append("image", this.user.image);
        }
        this.addUser(fd).then((response) => {
          if (response.data.code === 200) {
            this.getUserList();
            success_message(response.data.msg);
            this.$bvModal.hide("bv-modal-add-user");
            this.$v.$reset();
          } else {
            error_message(response.data.mmsg);
          }
        });
      }
    },
    onUserImagedeleted() {
      this.image = "";
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-6">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left d-flex align-items-center">
            <div class="avatar-xs mr-3">
              <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                <i class="bx bx-user"></i>
              </span>
            </div>
            <h4 class="mb-0 font-size-18">Users ({{ userCount }})</h4>
          </div>
        </div>
      </div>
      <div class="col-6 d-flex justify-content-end">
        <div class="page-title">
          <button
            class="btn btn-primary btn-md btn-rounded ml-1"
            @click="
              resetForm();
              $bvModal.show('bv-modal-add-user');
            "
          >
            Add User
          </button>
        </div>
        <div class="page-title-right">
          <a
            :href="config.appurl + 'download-users-data'"
            class="btn btn-primary btn-md btn-rounded ml-1"
          >
            Download All Data
          </a>
        </div>
      </div>
    </div>
    <div class="row list-table-main">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-2 offset-sm-6">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>Per Page :</label>
                    <select class="custom-select" v-model="perPage" @change="searchData()">
                      <option value="5" selected>5</option>
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>Status :</label>
                    <select class="custom-select" v-model="status" @change="searchData()">
                      <option value>Both</option>
                      <option value="1" selected>Active</option>
                      <option value="0">InActive</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="date-range-list">
                  <label>Search :</label>
                  <div class="text-sm-right">
                    <div class="search-box mr-2 d-inline-block">
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control"
                          id="search"
                          @input="searchData()"
                          v-model="search"
                          :placeholder="$t('navbar.search.text')"
                        />
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 table-main-list customer-table table-responsive">
                <b-table
                  :items="getAllUser || []"
                  :fields="fields"
                  :update:sortBy="sortBy"
                  :update:sortDesc="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :busy="loading"
                  show-empty
                  class="table-class"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(profile_image)="data">
                    <div v-if="data.item.profile_image">
                      <img
                        title="product-img"
                        class="avatar-md rounded-circle-banner"
                        :src="config.user + data.item.profile_image"
                        alt=""
                        height="30"
                        @error="$event.target.src = config.basepath + 'no_image.png'"
                      />
                    </div>
                    <div v-else>
                      <img
                        class="avatar-md rounded-circle-banner"
                        :src="config.basepath + 'no_image.png'"
                        alt=""
                      />
                    </div>
                  </template>
                  <template v-slot:cell(users)="data">
                    <p>&nbsp;{{ data.item.first_name }} {{ data.item.last_name }}</p>
                  </template>
                  <template v-slot:cell(status)="data">
                    <div
                      v-if="data.item.deleted_at"
                      class="badge badge-pill badge-soft-danger font-size-12 mt-2"
                    >
                      Deleted
                    </div>
                    <div v-else>
                      <div
                        v-if="data.item.status == 1"
                        class="badge badge-pill badge-soft-success font-size-12 mt-2"
                      >
                        Active
                      </div>
                      <div v-else class="badge badge-pill badge-soft-danger font-size-12 mt-2">
                        InActive
                      </div>
                    </div>
                  </template>

                  <template v-slot:cell(action)="data">
                    <router-link
                      :to="{ name: 'user-view', params: { id: base64(data.item.id) } }"
                      class="btn btn-primary btn-sm btn-rounded"
                      >View
                    </router-link>
                    <button
                      type="submit"
                      class="btn btn-danger btn-sm btn-rounded ml-1"
                      @click="deleteById(base64(data.item.id))"
                    >
                      Delete
                    </button>
                    <!-- <button
                      v-if="data.item.status == 1"
                      type="submit"
                      class="btn btn-danger btn-sm btn-rounded ml-1"
                      @click="blockUserById(base64(data.item.id))"
                    >
                      Block
                    </button>
                    <button
                      v-if="data.item.status == 0"
                      type="submit"
                      class="btn btn-success btn-sm btn-rounded ml-1"
                      @click="unblockUserById(base64(data.item.id))"
                    >
                      Unblock
                    </button> -->
                  </template>
                  <template #empty>
                    <p class="text-center">{{ $t("User not found") }}</p>
                  </template>
                </b-table>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="pagination"
                        :limit="limit"
                        @pagination-change-page="getUserList"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Add User Model -->
        <b-modal id="bv-modal-add-user" size="lg" hide-footer @hidden="resetForm">
          <template #modal-title>Add User</template>
          <form action="#" @submit.prevent="submitAddUser">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group mb-3">
                  <label>FirstName</label>
                  <input
                    id="first_name"
                    type="text"
                    class="form-control"
                    placeholder="Enter First Name"
                    v-model="$v.user.first_name.$model"
                    :class="{ 'is-invalid': $v.user.first_name.$error }"
                    name="first_name"
                  />
                  <div v-if="$v.user.first_name.$error" class="invalid-feedback">
                    <span v-if="!$v.user.first_name.required">First Name is required</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group mb-3">
                  <label>LastName</label>
                  <input
                    id="last_name"
                    type="text"
                    class="form-control"
                    placeholder="Enter Last Name"
                    v-model="$v.user.last_name.$model"
                    :class="{ 'is-invalid': $v.user.last_name.$error }"
                    name="last_name"
                  />
                  <div v-if="$v.user.last_name.$error" class="invalid-feedback">
                    <span v-if="!$v.user.last_name.required">Last Name is required</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group mb-3">
                  <label>Email</label>
                  <input
                    id="email"
                    type="text"
                    class="form-control"
                    placeholder="Enter email"
                    v-model="$v.user.email.$model"
                    :class="{ 'is-invalid': $v.user.email.$error }"
                    name="name"
                  />
                  <div v-if="$v.user.email.$error" class="invalid-feedback">
                    <span v-if="!$v.user.email.required">Please enter email</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group mb-3">
                  <label>Mobile Number [Use (+91)]</label>
                  <input
                    id="mobile_number"
                    type="text"
                    class="form-control"
                    placeholder="Enter Mobile Number"
                    v-model="$v.user.mobile_number.$model"
                    :class="{ 'is-invalid': $v.user.mobile_number.$error }"
                    name="mobile_number"
                  />
                  <div v-if="$v.user.mobile_number.$error" class="invalid-feedback">
                    <span v-if="!$v.user.mobile_number.required">Mobile Number is required.</span>
                    <span v-if="!$v.user.mobile_number.minLength"
                      >Please enter minimum 10 digit</span
                    >
                    <span v-if="!$v.user.mobile_number.maxLength"
                      >Please enter maximum 12 digit</span
                    >
                    <span v-if="!$v.user.mobile_number.mobileNumberValidator">
                      Format is not correct or special character not allowed</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-sm-6 vendor-status">
                <label>Status</label>
                <b-form-checkbox
                  switch
                  size="lg"
                  v-model="user.status"
                  class="ml-1"
                  value="1"
                  unchecked-value="0"
                ></b-form-checkbox>
              </div>
              <div class="col-sm-6">
                <div class="col-sm-3">
                  <dropzone-popup
                    type="file"
                    v-model="user.image"
                    id="profile_image"
                    acceptedFiles=".jpeg,.jpg,.png"
                    :delete-path="profile_image_delete_url"
                    @image-deleted="this.onUserImagedeleted"
                  />
                </div>
              </div>
            </div>
            <div class="text-end mt-3">
              <button
                type="button"
                @click="
                  resetForm();
                  $bvModal.hide('bv-modal-add-user');
                "
                class="btn btn-light"
              >
                Close</button
              >&nbsp;
              <button type="submit" class="btn ms-1 btn-success">Submit</button>
            </div>
          </form>
        </b-modal>
        <!-- Add User Model -->
      </div>
    </div>
  </Layout>
</template>
<style>
.table-class {
  table-layout: fixed;
}
.table-class th:first-child {
  width: 100px;
}
.table-class th:nth-child(5n) {
  width: 80px;
}
.table-class th:nth-child(4n) {
  width: 150px;
}
</style>
